import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.435 11.519H5.213a.74.74 0 0 0 0 1.481h2.222a.74.74 0 1 0 0-1.482m6.186-2.963h-1.652a4.074 4.074 0 1 0-7.867-1.481c-.001.506.094 1.01.282 1.48H2.732a.74.74 0 1 0 0 1.482H13.62a.74.74 0 1 0 0-1.481m-3.334 0H6.065a2.55 2.55 0 0 1-.481-1.482 2.593 2.593 0 0 1 5.185 0 2.55 2.55 0 0 1-.482 1.482m.852 2.963h-.74a.74.74 0 0 0 0 1.481h.74a.74.74 0 1 0 0-1.482"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })